import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import Header from './components/Header';
import Home from './pages/Home';
import Results from './pages/Results';
import Admin from './pages/Admin';
import Login from './pages/Login';
import Register from './pages/Register';
import VoteSite from './pages/VoteSite';
import VoteFb from './pages/VoteFb';
import VoteOtt from './pages/VoteOtt';
import CampaignFinished from './pages/CampaignFinished';
import { VotingOptionsProvider } from './context/VotingOptionsContext';
import './App.css';

// Check if we're on the client side
const isClient = typeof window !== 'undefined';

// Wrapper component for animations (only on client)
const AnimatedRoute = ({ children, ...props }) => {
  if (!isClient) {
    return children;
  }
  
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.3 }}
      {...props}
    >
      {children}
    </motion.div>
  );
};

function App() {
  const routes = (
    <Routes>
      <Route path="/" element={<AnimatedRoute><CampaignFinished /></AnimatedRoute>} />
      {/* <Route path="/" element={<AnimatedRoute><Home /></AnimatedRoute>} /> */}
      <Route path="/voting/site" element={<AnimatedRoute><VoteSite /></AnimatedRoute>} />
      <Route path="/voting/fb" element={<AnimatedRoute><VoteFb /></AnimatedRoute>} />
      <Route path="/voting/ott" element={<AnimatedRoute><VoteOtt /></AnimatedRoute>} />
      <Route path="/results" element={<AnimatedRoute><Results /></AnimatedRoute>} />
      <Route path="/admin" element={<AnimatedRoute><Admin /></AnimatedRoute>} />
      <Route path="/login" element={<AnimatedRoute><Login /></AnimatedRoute>} />
      <Route path="/register" element={<AnimatedRoute><Register /></AnimatedRoute>} />
    </Routes>
  );

  return (
    <div className="App">
      <Header />
      <VotingOptionsProvider>
        {isClient ? (
          <AnimatePresence mode="wait">
            {routes}
          </AnimatePresence>
        ) : (
          routes
        )}
      </VotingOptionsProvider>
    </div>
  );
}

export default App;
